import { debounce } from 'debounce';
import merge from 'deepmerge';

function isValueInPixel(value) {
    return /^(\d)+px$/.test(value);
}
function isArFontSize(value) {
    return ['xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'xxxs'].indexOf(value) > -1
        || isValueInPixel(value);
}
var overwriteMerge = function (destinationArray, sourceArray, options) { return sourceArray; };
function mergeObjects(objA, objB) {
    return merge(objA, objB, { arrayMerge: overwriteMerge });
}

var ARInput = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:['ar-input', (_vm.isFocused && !_vm.readonly) && 'focus', _vm.hasError && 'error', _vm.disabled && 'disabled'],attrs:{"ar-widget-id":"ar-input","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-input"},on:{"click":_vm.handleInputWrapperClick}},[_c('div',{ref:"left-section",class:[
      'left-section',
      _vm.leftSectionHasBackground && 'has-background' ],style:({
      marginRight: _vm.hasLeftSection ? '12px' : '0',
    }),on:{"click":_vm.handleLeftSectionClick}},[(_vm.iconName)?_c('ar-icon',_vm._b({},'ar-icon',_vm.decoratedIconProps,false)):_vm._e(),_vm._v(" "),(_vm.prefix)?_c('ar-text',{attrs:{"text":_vm.prefix,"size":"xs"}}):_vm._e()],1),_vm._v(" "),_c('input',_vm._b({ref:"input",class:[
      'input',
      _vm.$arBrowser.isFirefox && 'remove-bottom-padding',
      // Forces the placeholder to align to the right if the direction is auto or rtl
      !!_vm.direction && (_vm.direction === 'auto' || _vm.direction === 'rtl') && _vm.textSectionTextAlign === 'right' && 'text-align-right'
    ],style:({
      '-webkit-text-security': _vm.textSecure ? 'disc' : null,
      fontSize: _vm.inputFontSizeInPixel,
      paddingLeft: '0',
      paddingRight: "14px",
      // If direction is enabled, it overwrites whatever is set in align when the user types
      textAlign: !_vm.direction ? _vm.textSectionTextAlign : null,
    }),attrs:{"id":_vm.id,"readonly":_vm.readonly,"placeholder":_vm.placeholder,"maxlength":_vm.maxLength || 99999,"type":_vm.type,"disabled":_vm.disabled,"step":_vm.step,"min":_vm.min,"max":_vm.max,"autocomplete":_vm.autocomplete,"name":_vm.autocomplete,"dir":_vm.direction},domProps:{"value":_vm.realValue},on:{"input":_vm.handleInput,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnterClick($event)},"blur":_vm.handleInputBlur,"focus":_vm.handleInputFocus}},'input',_vm.integer ? { onkeydown: 'return event.key !== \'.\' && event.key !== \',\' && event.key !== \'-\' && event.key !== \'e\'' } : {},false)),_vm._v(" "),_c('div',{staticClass:"right-section"},[(_vm.enableClear && _vm.realValue)?_c('ar-icon-button',{staticClass:"clear-icon",attrs:{"icon-props":{
        name: 'cross',
        height: '12px',
        width: '12px',
      }},on:{"click":_vm.handleClearClick}}):_vm._e(),_vm._v(" "),(_vm.suffix)?_c('div',{staticClass:"suffix"},[_c('ar-text',_vm._b({},'ar-text',_vm.decoratedSuffixProps,false))],1):_vm._e(),_vm._v(" "),(_vm.maxLength)?_c('span',{staticClass:"length-text"},[_vm._v("\n      "+_vm._s(((_vm.maxLength - (_vm.realValue ? _vm.realValue.length : 0)) + " characters left"))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.label)?_c('div',{staticClass:"right-side-label",on:{"click":function($event){$event.stopPropagation();return _vm.handleLabelClick($event)}}},[_c('ar-text',_vm._b({},'ar-text',_vm.decoratedLabelProps,false))],1):_vm._e()],1)])},
staticRenderFns: [],
  name: 'Input',
  props: {
    arWidgetMeta: String,
    id: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    inputFontSize: {
      type: String,
      default: 'xs',
      validator: isArFontSize,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: null,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    maxLength: {
      type: Number,
      default: null,
    },
    step: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max : {
      type: Number,
      default: null,
    },
    integer : {
      type: Boolean,
      default: false,
    },
    debounce: {
      type: Boolean,
      default: false,
    },
    textSecure: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    enableSuffixBackground: {
      type: Boolean,
      default: false,
    },
    suffixProps: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: null,
    },
    labelProps: {
      type: Object,
      default: () => ({}),
    },
    // TODO - Revist this idea if we can think of a better solution
    formatter: {
      type: Function,
      default: null,
    },
    autocomplete: {
      type: String,
      default: 'audience-republic',
    },
    align: {
      type: String,
      default: 'left',
      validator: (value) =>
        ['left', 'right', 'center'].indexOf(value) !== -1,
    },
    direction: {
      type: String || null,
      default: null,
      validator: (value) =>
        ['auto', 'ltr', 'rtl', null].indexOf(value) !== -1,
    },
  },

  data() {
    return {
      isFocused: false,
      realValue: null,
      doNotTriggerBlurFlag: false, // When you don't want to trigger blur event
      handleInput: (event) => { this.handleInputChange(event); },
    };
  },

  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.realValue};`,
        `autocomplete=${this.autocomplete};`,
        `placeholder=${this.placeholder};`,
      ].join('');
    },
    hasLeftSection() {
      return this.iconName || this.prefix;
    },
    leftSectionHasBackground() {
      return !!this.prefix;
    },
    decoratedIconProps() {
      return mergeObjects({
        name: this.iconName,
        width: '16px',
        color: this.leftSectionHasBackground ? this.$arStyle.color.blueGrey800 : this.$arStyle.color.blueGrey600,
        style: {
          marginRight: this.prefix ? '8px' : '0',
        },
      }, this.iconProps);
    },
    decoratedSuffixProps() {
      return mergeObjects({
        text: this.suffix,
        size: this.inputFontSizeInPixel,
        style: {
          color: this.enableSuffixBackground ? this.$arStyle.color.blueGrey800 : this.$arStyle.color.blueGrey600,
        },
      }, this.suffixProps);
    },
    decoratedLabelProps() {
      return mergeObjects({
        size: 'xs',
        text: this.label,
        style: {
          color: this.$arStyle.color.blueGrey600,
        },
      }, this.labelProps);
    },
    inputFontSizeInPixel() {
      return this.$arStyle.font.size[this.inputFontSize] || this.inputFontSize;
    },
    textSectionTextAlign() {
      return this.align;
    },
  },

  watch: {
    value: {
      handler: function (val) {
        this.updateRealValue(val);
      },
      immediate: true,
    },
  },

  mounted() {
    if (this.autoFocus) {
      this.focus();
    }
  },

  // NOTE:
  //
  // Using debounce in methods won't work properly if there
  // are multiple instances of the same component. It will
  // only run the debounced method on the last-created component.
  //
  // See here: https://stackoverflow.com/a/49780382
  created() {
    if (this.debounce) {
      this.handleInput = debounce((event) => {
        this.handleInputChange(event);
      }, 250);
    }
  },

  methods: {
    focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    select() {
      if (this.$refs.input) {
        this.$refs.input.select();
      }
    },
    updateRealValue(val) {
      this.realValue = val;
    },
    handleClearClick() {
      this.updateRealValue('');
      this.$emit('input', '');
    },
    handleInputChange(event) {
      let newValue = event.target.value;
      // Use '.' after two 'spacebar' in a row
      if (newValue.substring(newValue.length - 2, newValue.length) === '  ') {
        newValue = `${newValue.substring(0, newValue.length - 2)}.`;
      }
      // Spacebar at first character is now allowed
      while (newValue.substring(0, 1) === ' ') {
        newValue = newValue.substring(1, newValue.length);
      }

      // TODO - Revist this idea if we can think of a better solution
      let newPosition = null;
      if(this.formatter) {
        const formatterReturn = this.formatter(this.$refs.input);
        newValue = formatterReturn.value;
        newPosition = formatterReturn.position;
      }

      this.updateRealValue(newValue);

      this.$emit('input', newValue);

      if (newPosition) this.$refs.input.setSelectionRange(newPosition, newPosition);
    },
    handleEnterClick(event) {
      // **Important** Remember to flag it before we blur input, we don't want to trigger blur event here
      this.doNotTriggerBlurFlag = true;
      this.$refs.input.blur();

      // If value changed
      const trimmedValue = event.target.value.trim();
      this.updateRealValue(trimmedValue);
      this.$emit('input', trimmedValue);
      this.$emit('enter', trimmedValue);
    },
    handleInputBlur(e) {
      this.isFocused = false; // Remember to set focus to false

      // Don't trigger event when flag is on
      if (this.doNotTriggerBlurFlag) {
        this.doNotTriggerBlurFlag = false;
        return;
      }

      this.$emit('blur', e);
    },
    handleLabelClick() {
      this.$emit('labelClick');
    },
    handleInputFocus() {
      this.isFocused = true;
      this.$emit('focus');
    },
    handleLeftSectionClick(event) {
      // If we have "prefix" in left seciton, than we stop propagation here,
      // otherwise it will eventually focus the input, and users will not
      // be able to select "prefix"
      if (this.prefix) {
        event.stopPropagation();
      }
    },
    async handleInputWrapperClick() {
      await this.$nextTick(); // Make sure handleInputFocus not gets called, prevent emitting 'focus' event twice.
      if (this.isFocused) {
        return;
      }
      this.focus();
    },
  },
};

export default ARInput;
